module.exports = __webpack_public_path__ + "static/media/OTCXR4.7117530e.png";